module.exports = __webpack_public_path__ + "media/KikiJD.390e37c0.mp3";